export default "__VITE_ASSET__h2lVoGan__"